import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import "@/App.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [hp, setHp] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, company_website: hp });
      setSent(true);
    } catch (err) {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg min-h-screen flex flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-md mmm-fade-up">
        <div className="flex flex-col items-center mb-6 text-center">
          <img src="https://customer-assets.emergentagent.com/job_c36fe051-3d1f-49c1-a3e2-d610d9af7ab4/artifacts/fhd5bl7q_MovingMyMama-Logo-Web.png"
            alt="MovingMyMama" className="h-20 w-20 object-contain mb-3" />
          <h1 className="font-display text-2xl font-bold text-[#1C4358]">Reset Password</h1>
        </div>
        <Card className="p-6 sm:p-7 border-[#E6EDF2]" style={{ boxShadow: "var(--mmm-shadow-md)" }}>
          {sent ? (
            <div className="text-center py-2" data-testid="forgot-success-message">
              <CheckCircle2 size={40} className="mx-auto mb-3 text-[#2F7D5A]" />
              <h2 className="font-display text-lg font-semibold text-[#252221] mb-1">Check your email</h2>
              <p className="text-sm text-muted-foreground">If that email exists, a reset link has been sent. The link expires in 60 minutes and can be used once. Be sure to check your spam folder.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <p className="text-sm text-muted-foreground">Enter your email and we'll send you a secure password reset link.</p>
              {/* honeypot — hidden from humans */}
              <input type="text" name="company_website" tabIndex={-1} autoComplete="off"
                value={hp} onChange={(e) => setHp(e.target.value)}
                style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} aria-hidden="true" />
              <div>
                <Label className="mb-1.5 block text-[13px] font-medium">Email</Label>
                <div className="relative">
                  <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    placeholder="you@movingmymama.com" className="pl-9 h-11" data-testid="forgot-email-input" />
                </div>
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="w-full h-11 text-white" style={{ backgroundColor: "var(--mmm-red)" }}>
                {loading ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}
              </Button>
            </form>
          )}
          <div className="text-center mt-5">
            <Link to="/login" className="inline-flex items-center text-sm font-medium text-[#1C4358] hover:underline">
              <ArrowLeft size={15} className="mr-1" /> Back to sign in
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
